import { client } from "../client/client";

export const getLoanOfficerPerformance = async (loanOfficerId) => {
  try {
    const response = await client.get(
      `/loan-officers/${loanOfficerId}/loan-summary`
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
